/** Контент лендинга `/use-cases/workout-timer` (вёрстка — `UseCasePageLayout`). */

import type { UseCasePageContent } from './useCasePageContent';

export const WORKOUT_TIMER_CONTENT: UseCasePageContent = {
  heroEyebrow: 'ТРЕНИРОВКИ, ФИТНЕС, ЙОГА',
  heroLead:
    'Превратите телефон, ноутбук или ТВ в таймер для тренировок. Соберите интервалы, выведите крупный отсчёт на экран и управляйте им с телефона — полноэкранный режим, цветовые зоны, без установки.',
  heroNote: 'Бесплатно. Без регистрации, в браузере.',

  scenarios: {
    title: 'Где пригодится',
    lead:
      'preztimer держит тайминг тренировки, медитации или групповой практики: отдельный таймер на каждый этап и крупный отсчёт на любом экране.',
    items: [
      {
        title: 'Интервальные тренировки',
        text: 'HIIT, табата и круговая: отдельный таймер на каждый интервал и смену станции, зоны перед концом.',
      },
      {
        title: 'Йога и пилатес',
        text: 'Таймеры на позы и дыхание, название позы — в заголовке таймера, чистый экран без лишнего.',
      },
      {
        title: 'Групповые занятия и буткемпы',
        text: 'Крупный отсчёт на большом экране, управление с телефона у тренера или таймкипера.',
      },
    ],
  },

  share: {
    title: 'Полноэкранный таймер на любом экране',
    paragraphs: [
      'Экран таймера открывается по ссылке в браузере. Выведите его на ТВ или монитор по кабелю (HDMI) либо беспроводным дублированием (AirPlay, screen mirroring) — крупный отсчёт читается с любого расстояния, размер подстраивается автоматически.',
      'Покажите ровно то, что нужно: оставьте только цифры или добавьте название этапа и прогресс-бар. Установка и регистрация не нужны — можно начать с гостевой комнаты.',
    ],
  },

  cloud: {
    title: 'Своя программа тренировки',
    lead:
      'Соберите программу под любой формат — интервалы, табата, йога или медитация.',
    bullets: [
      'таймер на каждый интервал, упражнение или позу со своей длительностью;',
      'название и описание у каждого таймера — видно, что сейчас идёт;',
      'переход к следующему таймеру — вручную с панели или с телефона.',
    ],
  },

  communication: {
    title: 'Управляйте и подсказывайте',
    lead:
      'Держите пульт в руке и передавайте команды на экран, не прерывая занятие.',
    bullets: [
      'запуск, пауза и сброс с телефона как с пульта;',
      'сообщения на экран — команда или следующее упражнение;',
      'кнопки добавляют или убавляют время прямо по ходу.',
    ],
  },

  modes: {
    title: 'Цвета, зоны и прогресс-бар',
    lead:
      'Сигналы окончания — визуальные: цвет, зоны и мигание, без звука.',
    bullets: [
      'цветовой прогресс-бар по сегментам под отсчётом;',
      'жёлтая и красная зоны перед концом, мигание в красной;',
      'обратный отсчёт, секундомер или часы (время суток), перерасход после нуля.',
    ],
  },

  pricing: {
    title: 'Цены',
    lead:
      'Для тренера и небольшого зала базовых функций хватит — бесплатно. Профи добавляет больше таймеров, комнат и подключений.',
  },

  crossLink: {
    title: 'Связанный сценарий: уроки и занятия',
    lead:
      'Таймер для урока, экзамена и класса — отдельная страница для образования и учебных активностей.',
    to: '/use-cases/online-timer-for-education',
    linkLabel: 'Онлайн-таймер для урока',
  },

  faqSectionTitle: 'Частые вопросы о таймере для тренировок',
  faqItems: [
    {
      question: 'Можно ли использовать как интервальный таймер в зале?',
      answer:
        'Да. Создайте таймеры на интервалы и смены станций, откройте экран таймера и выведите его на ТВ или монитор — по кабелю HDMI или беспроводным дублированием с телефона, планшета или ноутбука.',
    },
    {
      question: 'Играет ли таймер звук или сигнал?',
      answer:
        'Нет. Звуковых сигналов сейчас нет — preztimer беззвучный. Окончание интервала видно по визуальным сигналам: цветовые зоны, мигание в красной зоне и показ перерасхода после нуля.',
    },
    {
      question: 'Можно ли запустить таймеры автоматически по очереди?',
      answer:
        'Автозапуска цепочкой «hands-free» пока нет: к следующему таймеру вы переходите вручную с панели управления, в том числе с телефона. Старт отдельного таймера можно запланировать на конкретное время.',
    },
    {
      question: 'Моего вида тренировки нет в списке — подойдёт?',
      answer:
        'Да. Добавьте таймер на каждый этап с нужной длительностью, названием и описанием — так соберёте программу под любую тренировку, практику или режим.',
    },
    {
      question: 'Можно ли показывать только часы (время суток)?',
      answer:
        'Да. У таймера есть режим часов — выберите его в типе таймера, и на экране будет текущее время суток вместо отсчёта.',
    },
    {
      question: 'Нужен ли интернет и аккаунт?',
      answer:
        'preztimer работает в браузере онлайн, устанавливать ничего не нужно. Начать можно без регистрации — в гостевой комнате; аккаунт нужен, чтобы сохранять комнаты и подключать команду.',
    },
  ],
};
